
import {useParams} from 'react-router-dom'
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
// reactstrap components
import {
  Button, InputGroup, InputGroupText, Spinner,
  Card,Badge, Modal, ModalBody, ModalHeader,
  CardHeader, 
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import CreateVInfo from './CreateVInfon'
import Spin from '../../../assets/img/Spinner2.gif'
import { Rating } from 'react-simple-star-rating'
import swal from "sweetalert";
import {customStyles} from '../../../helpers/mycomps'


const months = [
  {value : 0, label : "Jan"},
  {value : 1, label : "Feb"},
  {value : 2, label : "Mar"},
  {value : 3, label : "April"},
  {value : 4, label : "May"},
  {value : 5, label : "June"},
  {value : 6, label : "July"},
  {value : 7, label : "Aug"},
  {value : 8, label : "Sept"},
  {value : 9, label : "Oct"},
  {value : 10, label : "Nov"},
  {value : 11, label : "Dec"}
]

const cats = [
   {value : 1 , categoryCode : "1" , label : "Cars"},
   {value : 2 , categoryCode : "2" , label : "Yachts"}, 
   {value : 3 , categoryCode : "3" , label : "Machines"}
]


function ListingApproval(props) {
  let d = new Date()
  d.setDate(d.getDate() - 7);

    const tuid = useParams()
    const [showProcessing, setShowProcessing] = useState(false)
    const [tlisting, setListing] = useState([])
       
    const [infom, setInfom] = useState(false)

    const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>
    const [vehicle , setVehicle ] = useState({
        vid : "",
        luid : "",
        tluid: "",
        tuid : "",
        listingtype : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}],
        insurence : true,
        intcolor  : "",
        extcolor : "",
        approxmiles : "",
        daily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fdaily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        weekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fweekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        monthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fmonthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fuelCode : "",
        fuelName  : {en :"", fr : "", ar: ""},
        trmCode : "",
        trmName : {en : "", fr : "", ar : ""}
      })
     
      const [month , setMonth] = useState({value : d.getMonth() , label : d.toLocaleString('default', { month: 'short' })})
  
  

    const [dbdata, setDbdata] = useState({
        totallisting : "0",
        countp  : "0",
        countf  : "0",
        countd : "0",
        countclickstotal : "0",
        countclicksdetails : "0",
        countclicksenquiry : "0",
        countclickswa : "0",
        countclickscall : "0"
      })
    
      

    const tenlisting = () => {
        
        setShowProcessing(true)
        props.API.get(`tenant/tlisting/${tuid.tuid}`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            //  basicAlert(res.data.message)
              setShowProcessing(false)
             
              let data = res.data.data[0].listings.map((g, key) => {
                
                return {
                    key : key,
                    cLogo : res.data.data[0].cLogo,
                    mngName : res.data.data[0].mngName,
                    cellNumber : res.data.data[0].cellNumber,
                    managerid : res.data.data[0].managerid,
                    city : res.data.data[0].city,
                    tuid : res.data.data[0].tuid , 
                    luid : g.luid,
                    tluid: g.tluid,
                    category  : g.category,
                    bname : g.bname,
                    mname : g.mname,
                    modelyear : g.modelyear,
                    vtname : g.vtname,
                    notes : g.notes,
                    daily : g.daily,
                    imgmc : g.imgmc,
                    fdaily : g.fdaily,
                    lrating : g.lrating,
                    listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                    actions:(  <div>
                              <Rating
                                   onClick={f => {
                                    let obj = data.find((o) => o.key === key);
                                    handleRating(obj.tuid, obj.tluid, f)
                                }}
                                initialValue={g.lrating}
                                size = "20"
                                allowFraction	
                                 />
                        </div>),
            
                }
              })
               
             
              setListing(data)
            }).catch(function (error) {
                console.log(error)
              setShowProcessing(false)
              if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
              }
            }) 
    }


    useEffect(() => {
        tenlisting()
        getstats()
    },[tuid])



    const displayl = () => {
        try{
          return (
           <>
           <Card>
                <Row>
                <Col md="2"><img src={`${process.env.REACT_APP_APIURL}/limg/${tlisting[0].tuid}/${tlisting[0].cLogo}`} alt = "ten" width="200px" style={{maxWidth : "100px" , maxHeight : "100px"}}/></Col>
                    {/* <Col md="2"><img src={`${tlisting[0].cLogo}`} alt = "ten" width="200px" style={{maxWidth : "100px" , maxHeight : "100px"}}/></Col> */}
                    <Col md="10">
                        <Row style={{marginTop : 5}}>
                          <Col md="8"><h6>Tenant ID : {tlisting[0].tuid}</h6></Col>
                          <Col md="2">
                                   {/**   <Select options={cats} styles={customStyles} className={"shadow"} style={{paddingRight: 10}}
                                                onChange={e=> {setCat(e)}} value={cat}  /> */}
                          </Col>
                          <Col md="2" >
                          <Select options={months} styles={customStyles} className={"shadow"} 
                                                onChange={e=> {setMonth(e); getstatsx(e.value)}} value={month}  />
                          </Col>      
                            
                        </Row>
                        <Row style={{marginTop : 10}}><Col><h6>{tlisting[0].mngName}</h6></Col><Col><span  style={{float : "right", paddingRight : 20}}>{tlisting[0].managerid}</span></Col></Row>
                        <Row style={{marginTop : 5}}><Col>{tlisting[0].cellNumber}</Col><Col><span  style={{float : "right", paddingRight : 20}}>{tlisting[0].city.en}</span></Col></Row>
                    </Col>
                </Row>
              
            </Card>
            <Card>
                   
                   <CardBody >
                         <ReactTable 
                           data= {tlisting}
                           columns={[
                             {
                                 Header: "img",
                                 accessor: d =>  <center><img alt="..." width={"100px"} src={`${d.imgmc}`} style={{ cursor : "pointer"}} onClick={t => imgclick(d)}/> </center>,
                               },
                               {
                                   Header: "ListID",
                                   accessor: d =>  d.luid,
                                 },
                             {
                               Header: "C.Name",
                               accessor: d =>  d.category.en + " " + d.category.ar ,
                             },
                            
                             {
                               Header: "Brand",
                               accessor: d => d.bname.en + " " + d.bname.ar,
                             },
                             {
                                 Header: "Model",
                                 accessor: d =>  d.mname.en + " " + d.mname.ar,
                               },
                               {
                                   Header: "Year",
                                   accessor: d =>  d.modelyear.label ,
                                 },
                                 {
                                   Header: "Type",
                                   accessor: d =>  d.vtname.en ,
                                 },
                                 {
                                   Header: "Specs",
                                   accessor: d =>  d.notes ,
                                 },
                              
       
                           {
                                   Header: "Daily",
                                   accessor: d =>  <span>{d.daily.amt} /  <span style={{color: "green"}}>{d.fdaily.amt}</span></span>,
                           },
                                {
                                    Header: "Status",
                                    accessor: d =>  d.listingStatus === "Listed" ? <Badge color="primary" style={{cursor : "pointer"}} onClick={x => edlisting(d)}>Listed</Badge> : <Badge color="danger" onClick={x => edlisting(d)} style={{cursor : "pointer"}}>Awaiting...</Badge>,
                                    },
                             {
                               Header: "Rating",
                               accessor: d => d.actions,
                               sortable: false,
                               filterable: false,
                             },
                           ]}
                           /*
                               You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                             */
                           className="-striped -highlight primary-pagination"
                         />
                       </CardBody>
                    
             </Card>
             </>
          )  
        }catch(e){
            
            return (
                <h6>No listing for this tenant exist.</h6>
            )
            
        }
    }

    const handleRating = (tuid, f , rate) => {
        setShowProcessing(true)
        
    
            props.API.get(`tenant/edlistingrate/${tuid}/${f}/${rate}`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.data[0].listings.map((g, key) => {
                
                    return {
                        key : key,
                        cLogo : res.data.data[0].cLogo,
                        mngName : res.data.data[0].mngName,
                        cellNumber : res.data.data[0].cellNumber,
                        managerid : res.data.data[0].managerid,
                        city : res.data.data[0].city,
                        tuid : res.data.data[0].tuid , 
                        luid : g.luid,
                        tluid: g.tluid,
                        category  : g.category,
                        bname : g.bname,
                        mname : g.mname,
                        modelyear : g.modelyear,
                        vtname : g.vtname,
                        notes : g.notes,
                        daily : g.daily,
                        fdaily : g.fdaily,
                        lrating : g.lrating,
                        imgmc : g.imgmc,
                        listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                        actions:(  <div>
                                  <Rating
                                       onClick={f => {
                                        let obj = data.find((o) => o.key === key);
                                        handleRating(obj.tuid, obj.tluid, f)
                                    }}
                                    size = "20"
                                    allowFraction	
                                    initialValue={g.lrating}
                                     />
                            </div>),
                
                    }
                  })
                setListing(data)
            setShowProcessing(false)
         
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              swal("Error setting listing rating")
            }
             
          }) 

       // setRating(rate)
       
        // other logic
      }

      const edlisting = (e) => {
        
        let tuid = e.tuid
        let tluid = e.tluid
        let invStatus = e.listingStatus === "Listed" ? false : true
        setShowProcessing(true)
            props.API.get(`tenant/edlisting/${tuid}/${tluid}/${invStatus}`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.data[0].listings.map((g, key) => {
                  
                    return {
                        key : key,
                        cLogo : res.data.data[0].cLogo,
                        mngName : res.data.data[0].mngName,
                        cellNumber : res.data.data[0].cellNumber,
                        managerid : res.data.data[0].managerid,
                        city : res.data.data[0].city,
                        tuid : res.data.data[0].tuid , 
                        luid : g.luid,
                        tluid: g.tluid,
                        category  : g.category,
                        bname : g.bname,
                        mname : g.mname,
                        modelyear : g.modelyear,
                        vtname : g.vtname,
                        notes : g.notes,
                        daily : g.daily,
                        fdaily : g.fdaily,
                        lrating : g.lrating,
                        imgmc : g.imgmc,
                        listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                        actions:(  <div>
                                  <Rating
                                       onClick={f => {
                                        let obj = data.find((o) => o.key === key);
                                        handleRating(obj.tuid, obj.tluid, f)
                                    }}
                                    size = "20"
                                    allowFraction	
                                    initialValue={g.lrating}
                                     />
                            </div>),
                
                    }
                  })
                setListing(data)
            setShowProcessing(false)
         
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              swal("Error setting listing rating")
            }
             
          }) 
      }

     const imgclick = (tluid) => {
      
        setInfom(true)
        setVehicle(tluid)

     } 


     const getstats = () => {
    
      props.API.get(`/ten/dblc/${tuid.tuid}/${month.value}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
       setDbdata({ 
        totallisting : res.data.totallisting,
        countp : res.data.countp, 
        countf  : res.data.countf,
        countd : res.data.countd,
        countclickstotal : res.data.countclickstotal,
        countclicksdetails : res.data.countclicksdetails,
        countclicksenquiry : res.data.countclicksenquiry,
        countclickswa : res.data.countclickswa,
        countclickscall : res.data.countclickscall
       })
  
      }).catch(function (error) {
        console.log(error)
        setShowProcessing(false)
        
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }       
      }) 
      setShowProcessing(false)
     }
  
     const getstatsx = (x) => {
    
      props.API.get(`/ten/dblc/${tuid.tuid}/${x}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
       setDbdata({ 
        totallisting : res.data.totallisting,
        countp : res.data.countp, 
        countf  : res.data.countf,
        countd : res.data.countd,
        countclickstotal : res.data.countclickstotal,
        countclicksdetails : res.data.countclicksdetails,
        countclicksenquiry : res.data.countclicksenquiry,
        countclickswa : res.data.countclickswa  
       })
  
      }).catch(function (error) {
        console.log(error)
        setShowProcessing(false)
        
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }       
      }) 
      setShowProcessing(false)
     }
  

    return (
        
        <div className='content'>
              <CreateVInfo vehicle={vehicle} setInfom={setInfom} infom={infom} API={props.API}/>
              
              <Row>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-globe text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p style={{fontSize : "0.6rem"}} className="card-category">Enquiry / WA / Calls</p>
                      <CardTitle style={{fontSize : "0.9rem"}} tag="p">{Number(dbdata?.countclicksenquiry)} /  {Number(dbdata?.countclickswa)} / {Number(dbdata?.countclickscall)}  </CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()} />
                  Total Enquiry for the month {month.label}
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-money-coins text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category" style={{fontSize : "0.6rem"}}>Details</p>
                      <CardTitle tag="p" style={{fontSize : "0.9rem"}}>{dbdata.countclicksdetails}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-calendar-o" onClick={h => getstats()} />
                  Details clicked for the month {month.label}
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-vector text-danger" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Premium / Featured / Delisted</p>
                      <CardTitle tag="p" style={{fontSize : "0.9rem"}}>{dbdata.countp} / {dbdata.countf} /{dbdata.countd}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-clock-o" onClick={h => getstats()}/>
                  Listing by type 
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-favourite-28 text-primary" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">My List</p>
                      <CardTitle tag="p" style={{fontSize : "0.9rem"}}>{dbdata.totallisting}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()}/>
                  Total Listings 
                </div>
              </CardFooter>
            </Card>
          </Col>
             </Row>

            {showProcessing && SpinnerNew}
            {displayl()}
          
        </div>
    );
}

export default ListingApproval;